/* eslint-disable */
import axios from "axios";

// Send cookies on every cross-origin request
axios.defaults.withCredentials = true;

// Send stored Bearer token on every request for API clients that need it
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// common error handler
const handleError = (error) => {
  if (error.response) {
    const { status, data } = error.response;
    return {
      status: false,
      code: status,
      message: data?.message || `Request failed with status ${status}`,
    };
  } else if (error.request) {
    return {
      status: false,
      message: "No response from server. Please try again later.",
    };
  } else {
    return {
      status: false,
      message: error.message || "Unknown error occurred",
    };
  }
};

// common request function
const request = async (method, url = "", params = {}) => {
  try {
    let response;

    if (method === "get" || method === "delete") {
      response = await axios[method](url);
    } else {
      response = await axios[method](url, params);
    }
    return { status: true, data: response.data };
  } catch (error) {
    return handleError(error);
  }
};

// GET
const getData = (url = "") => request("get", url);

// POST
const postData = (url = "", inputData = {}) => request("post", url, inputData);

// PUT
const putData = (url = "", inputData = {}) => request("put", url, inputData);

// DELETE
const deleteData = (url = "") => request("delete", url);

// upload single file
const uploadSingleFile = async (url, file) => {
  try {
    const formData = new FormData();
    const uniqueName = `${file.name.split(".")[0]}_${Math.random()
      .toString(36)
      .substring(2, 15)}.${file.name.split(".").pop()}`;
    formData.append("upload", file, uniqueName);

    const { data } = await axios.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return { status: true, data };
  } catch (error) {
    return handleError(error);
  }
};

// upload multiple files
const uploadMultipleFile = async (url, files = []) => {
  try {
    const formData = new FormData();

    Object.keys(files).forEach((key) => {
      const file = files[key];
      const uniqueName = `${file.name.split(".")[0]}_${Math.random()
        .toString(36)
        .substring(2, 15)}.${file.name.split(".").pop()}`;
      formData.append("uploads", file, uniqueName);
    });

    const { data } = await axios.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return { status: true, data };
  } catch (error) {
    return handleError(error);
  }
};

//upload single file method
const uploadNonUniqueSingleFile = async (url, file) => {
  try {
    const formData = new FormData();
    formData.append("upload", file);

    const { data } = await axios.post(url, formData);

    return { status: true, data };
  } catch (error) {
    return handleError(error);
  }
};

//upload multiple file method
const uploadNonUniqueMultipleFiles = async (url, formValues = []) => {
  try {
    const formData = new FormData();

    let objArray = Object.keys(formValues);

    objArray.forEach((element) => {
      formData.append("uploads", formValues[element]);
    });

    const { data } = await axios.post(url, formData);

    return { status: true, data };
  } catch (error) {
    return handleError(error);
  }
};

export {
  getData,
  postData,
  putData,
  deleteData,
  uploadSingleFile,
  uploadMultipleFile,
  uploadNonUniqueSingleFile,
  uploadNonUniqueMultipleFiles,
};
